module.exports = __webpack_public_path__ + "img/Aeris.12a7148.png";